import React, { Component, useEffect, useRef, useState } from 'react';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingState } from '../../_common/loadingState';
import * as Loadings from '../../constants/loadings/backoffice/partners';

import * as R from 'ramda';

import { PartnersMain } from './main';
import { PartnersDetail } from './detail';

import { GetPartners } from '../../actions/backoffice/partners';


export const Partners = ({ user }) => {
	const dispatch = useDispatch();
	const partnersReducer = useSelector(state => state.partnersReducer);

	return (
		<Switch>
			<Route exact path="/backoffice/partners">
				<PartnersMain user={user} partners={partnersReducer.partners} partnerState={partnersReducer} isLoading={partnersReducer.isLoading} />
			</Route>
			<Route path="/backoffice/partners/:partnerId">
				<PartnersDetail user={user} partnerState={partnersReducer} partners={partnersReducer.partners} isLoading={partnersReducer.isLoading} />
			</Route>
			<Route render={() => {
				return <Redirect exact to="/backoffice/partners" />;
			}} />
		</Switch>
	);

};